import { initializeApp } from "firebase/app";
import { getMessaging ,isSupported  } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
 
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBcGMnOTWK9KtTXYkAvFcNQxoUK5D2WpSs",
  authDomain: "sitesnap-1ca1a.firebaseapp.com",
  projectId: "sitesnap-1ca1a",
  storageBucket: "sitesnap-1ca1a.firebasestorage.app",
  messagingSenderId: "1076698792759",
  appId: "1:1076698792759:web:5fee9ce7dff54a8479d0b2"
};
 
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = (await isSupported()) ? getMessaging(app) : {};